{
  "pt": {
    "phase": {
      "attributes": {
        "end_date": "Data final",
        "internal_note": "Nota interna da fase",
        "name": "Nome",
        "start_date": "Data de início"
      },
      "labels": {
        "phase": "Sem fase | Uma fase | {count} Fases"
      },
      "toasts": {
        "create": "Fase criada",
        "delete": "Fase eliminada",
        "update": "Fase atualizada"
      },
      "validation": {
        "needName": "O título é obrigatório",
        "needNumber": "Deve ser um número (por exemplo, 85)"
      }
    }
  }
}
